import $ from 'jquery';
import { trace } from 'rytm-helpers'
import { updateLinks } from './linksFix'
import { updatePostColumns } from './../cdz/post-columns'


// ### Window update
export const windowUpdate = (e) => {
  updateLinks()
  updatePostColumns()
};



export const removeReCaptchaBadge = () => {
  const list = [...document.querySelectorAll(".grecaptcha-badge")]
  list.forEach((el) => {
    const parentDiv = el.parentNode
    parentDiv.removeChild(el)
    // remove DIV
    parentDiv.parentNode.removeChild(parentDiv)
  })
}

// ### INIT
export const initCommon = () => {
  $(document).on('DOMContentLoaded load', windowUpdate);
  $(window).on('resize', windowUpdate);
  $('body').on('click', '.print-me', (e)=> {
    e.preventDefault();
    window.print();
  });
  // window update
  windowUpdate();
};

